<template>
  <v-card>
    <v-container>
      <v-row justify="center">
        <v-img class="ma-2" max-width="300" src="/livesync_logo.png" />
      </v-row>
      <span class="font-weight-bold ml-4">Forgot Password</span>
      <v-card-text>
        <div class="mt-4 mb-6">
          <span>Enter a registered account's email address below
            <br>and request a verification code. In the next step,
            <br>you can change your password by using the code.</span>
        </div>
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="username"
            :rules="emailRules"
            type="email"
            label="Email"
            required
            autocomplete="username"
            placeholder=" "
            ref="focusedField"
          ></v-text-field>
          <v-layout row class="bottom">
            <span
              class="return-to-signin"
              @click="back"
            >
              &larr; Back to Sign In page
            </span>
            <v-btn
              color="blue"
              :disabled="!valid"
              light
              @click="requestCode"
            >
              Request code
            </v-btn>
          </v-layout>
        </v-form>
        <div class="auth-error" v-if="error">
          {{ error }}
        </div>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { Auth, Logger } from 'aws-amplify';
import EventBus from '@/utils/EventBus';

const logger = new Logger('ForgotPassword');

export default {
  name: 'ForgotPasswordView',
  props: {
    mail: {
      type: String,
      required: false,
    },
    click: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      error: '',
      valid: true,
      emailRules: [
        (v) => !!v || 'Email is required',
        (v) => /.+@.+/.test(v) || 'Email must be valid',
      ],
    };
  },
  mounted() {
    setTimeout(this.focusOnField, 1000);
  },
  computed: {
    username: {
      get() {
        return this.mail;
      },
      set(newval) {
        this.$emit('update:mail', newval);
      },
    },
  },
  components: {
  },
  methods: {
    requestCode() {
      Auth.forgotPassword(this.username)
        .then(() => {
          EventBus.$emit('authState', 'CHANGE_PASSWORD');
        })
        .catch((e) => this.setError(e));
    },
    back() {
      EventBus.$emit('authState', 'LOG_IN');
    },
    setError(e) {
      this.error = e.message || e;
      logger.error(this.error);
    },
    focusOnField() {
      this.$refs.focusedField.focus();
    },
  },
};
</script>

<style scoped>
.auth-error {
  margin: 5px;
  padding: 3px;
  color: #E91300;
}
.bottom {
  justify-content: space-between;
  align-items: center;
}
.return-to-signin:hover {
  text-decoration: underline;
  cursor: pointer;
  color: #e66465;
}
</style>
